import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {

    // 1. Google Analytics ke liye (yeh aapke paas pehle se hai)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname,
    });

    // 2. Meta Pixel ke liye (yeh nayi line hai)  
    ReactPixel.pageView();
    
  }, [location]);

  return null;
};

export default RouteChangeTracker;
